export const SESSION_EXPIRED_REDIRECT_TOAST_KEY = 'session-expired-redirect-toast';
